var LUX_SPEC_NAMES = Object.freeze({
  DIM: "dim",
  NORMAL: "normal",
  WASHED: "washed"
});

export default LUX_SPEC_NAMES;